import { render, staticRenderFns } from "./modifysign.vue?vue&type=template&id=52a5aa7e"
import script from "./modifysign.vue?vue&type=script&lang=js"
export * from "./modifysign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports